export default "__VITE_ASSET__BT8WKB1Y__"